import {
  TVitalHistoryState,
  TVitalHistoryType,
  TGetHistoryRequestPayload,
  TVitalHistoryTimeline,
  TVitalHistoryMeta,
  TVitalHistoryList,
} from '../../types/vital-history';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ITimelineParams, TTimelineState } from '../../types/vital-data';

const initialState: TVitalHistoryState = {
  list: null,
  chartData: null,
  meta: null,
  timelineData: {},
};

const vitalHistorySlice = createSlice({
  name: 'vitalHistory',
  initialState,
  reducers: {
    getChartDataRequest: (state, _: PayloadAction<TGetHistoryRequestPayload>) => {
      state.getChartDataRequestStatus = 'pending';
    },
    getChartDataSuccess: (state, action: PayloadAction<TVitalHistoryTimeline[]>) => {
      state.chartData = action.payload;
    },
    getHistoryMetaRequest: (state, _: PayloadAction<TVitalHistoryType>) => {
      state.getHistoryMetaRequestStatus = 'pending';
    },
    getHistoryMetaSuccess: (state, action: PayloadAction<TVitalHistoryMeta>) => {
      state.meta = action.payload;
    },
    getHistoryListRequest: (state, _: PayloadAction<TGetHistoryRequestPayload>) => {
      state.listStatus = 'pending';
    },
    getHistoryListSuccess: (state, action: PayloadAction<TVitalHistoryList[]>) => {
      state.list = action.payload;
    },

    /**
     * Get timeline for vital detail
     */
    getTimelineRequest: (state, _: PayloadAction<ITimelineParams>) => {
      state.getTimelineStatus = 'pending';
    },
    getTimelineSuccess: (state, action: PayloadAction<TTimelineState>) => {
      state.getTimelineStatus = 'success';
      state.timelineData = {
        ...state.timelineData,
        ...action.payload,
      };
    },
    getTimelineError: (state) => {
      state.getTimelineStatus = 'error';
    },
    getTimelineReset: (state) => {
      state.getTimelineStatus = undefined;
    },
  },
});

export const { actions, name, reducer } = vitalHistorySlice;
export default reducer;
